// pages/index.tsx
import {FC, useEffect} from 'react';
import {useRouter} from 'next/router';

const Home: FC = () => {
  const router = useRouter();

  useEffect(() => {
    router.replace('/history');
  }, [router]);

  return null;
};

export default Home;
